import { compose, lifecycle, setDisplayName } from 'react-recompose';
import { fetchUser, fetchUserSsoData } from '~/state/ducks/users/operations';
import { getUserData, getSSOData, getUserID, isFetchingSSOData } from '~/state/ducks/users/selectors';
import { connect } from 'react-redux';
import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading';

import UserView from '../components/UserView';

const mapDispatchToProps = dispatch => ({
    fetchUserData: id => dispatch(fetchUser(id)),
    fetchSSOData: (userId) => {
        dispatch(fetchUserSsoData(userId));
    },
});


const mapStateToProps = state => ({
    data: getUserData(state),
    ssoData: getSSOData(state),
    userId: getUserID(state),
    isFetchingSSOData: isFetchingSSOData(state),
});

const withUserData = compose(
    setDisplayName('UsersViewContainer'),
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
        componentDidMount() {
            const {
                match: { params: { id } }, fetchUserData, userId, fetchSSOData,
            } = this.props;
            fetchUserData(id);
            if (userId) {
                fetchSSOData(userId);
            } else {
                console.error('componentDidMount - userId is undefined');
            }
        },
        componentDidUpdate(prevProps) {
            if (this.props.userId !== prevProps.userId) {
                const { userId, fetchSSOData } = this.props;
                fetchSSOData(userId);
            }
        },
    }),


    withReduxDataLoading({
        name: 'fetchUserData',
        operation: ({ match: { params: { id } } }) => fetchUser(id),
        selector: getUserData,
    }),
    withLoadingBranch,
);

export default withUserData(UserView);
